import state from './moduleVerUpdState.js'
import mutations from './moduleVerUpdMutations.js'
import actions from './moduleVerUpdActions.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
